
import gql from 'graphql-tag';
import { BaseService } from './BaseService';
import { FetchResult } from 'apollo-link';
import vesselUpsertMutation from '@/graphql/mutations/UpsertVessel.gql';
import { VesselInput, VesselFields } from '@/types/graphql/schemaTypes';

class VesselService extends BaseService {
  public upsertVessel(vesselArgs: VesselInput, vesselId?: string): Promise<FetchResult<VesselFields>> {
    return this.client.mutate({
      mutation: vesselUpsertMutation,
      variables: { vesselId, vesselArgs }
    });
  }
}

export const vesselService = new VesselService();
